import { render, staticRenderFns } from "./UserPermissionsList.vue?vue&type=template&id=1a1a94ca"
import script from "./UserPermissionsList.vue?vue&type=script&lang=js"
export * from "./UserPermissionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports